import type { PlanListFilters, UUID } from './types';

export const queryKeys = {
  traeger: {
    all: ['traeger'] as const,
    list: () => [...queryKeys.traeger.all, 'list'] as const,
    detail: (id: UUID) => [...queryKeys.traeger.all, 'detail', id] as const,
  },
  einrichtung: {
    all: ['einrichtung'] as const,
    list: (traegerId: UUID | null) => [...queryKeys.einrichtung.all, 'list', traegerId] as const,
    detail: (id: UUID) => [...queryKeys.einrichtung.all, 'detail', id] as const,
  },
  plaene: {
    all: ['plaene'] as const,
    list: (filters: PlanListFilters) => [...queryKeys.plaene.all, 'list', filters] as const,
    detail: (id: UUID) => [...queryKeys.plaene.all, 'detail', id] as const,
  },
  belegung: {
    all: ['belegung'] as const,
    plan: (planId: UUID) => [...queryKeys.belegung.all, planId] as const,
    gruppen: (planId: UUID) => [...queryKeys.belegung.all, 'gruppen', planId] as const,
    monate: (planId: UUID) => [...queryKeys.belegung.all, 'monate', planId] as const,
    personalbedarf: (planId: UUID, basis: string = 'belegung') =>
      [...queryKeys.belegung.all, 'personalbedarf', planId, basis] as const,
    /** Prefix über beide Sichten (Belegung und Betriebserlaubnis) — zum
     *  Invalidieren, damit ein Wechsel der Daten nicht nur eine davon
     *  erneuert und die andere veraltet stehen lässt. */
    personalbedarfAlle: (planId: UUID) =>
      [...queryKeys.belegung.all, 'personalbedarf', planId] as const,
    integrationKinder: (planId: UUID) =>
      [...queryKeys.belegung.all, 'integrationKinder', planId] as const,
  },
  personal: {
    all: ['personal'] as const,
    plan: (planId: UUID) => [...queryKeys.personal.all, planId] as const,
  },
  sach: {
    all: ['sach'] as const,
    plan: (planId: UUID) => [...queryKeys.sach.all, planId] as const,
    katalogansicht: (planId: UUID) => [...queryKeys.sach.all, 'katalogansicht', planId] as const,
  },
  finanzierung: {
    all: ['finanzierung'] as const,
    plan: (planId: UUID) => [...queryKeys.finanzierung.all, planId] as const,
  },
  betreuungspreis: {
    all: ['betreuungspreis'] as const,
    einrichtung: (einrichtungId: UUID) => [...queryKeys.betreuungspreis.all, einrichtungId] as const,
    plan: (planId: UUID) => [...queryKeys.betreuungspreis.all, 'plan', planId] as const,
  },
  einnahmen: {
    all: ['einnahmen'] as const,
    kommune: (planId: UUID) => [...queryKeys.einnahmen.all, 'kommune', planId] as const,
    land: (planId: UUID) => [...queryKeys.einnahmen.all, 'land', planId] as const,
    sonstige: (planId: UUID) => [...queryKeys.einnahmen.all, 'sonstige', planId] as const,
    landAufschluesselung: (planId: UUID) =>
      [...queryKeys.einnahmen.all, 'land-aufschluesselung', planId] as const,
  },
  snapshot: {
    all: ['snapshot'] as const,
    plan: (planId: UUID) => [...queryKeys.snapshot.all, planId] as const,
  },
  vergleich: {
    all: ['vergleich'] as const,
    diff: (a: UUID, b: UUID) => [...queryKeys.vergleich.all, a, b] as const,
  },
  admin: {
    all: ['admin'] as const,
    tvoed: () => [...queryKeys.admin.all, 'tvoed'] as const,
    sv: () => [...queryKeys.admin.all, 'sv'] as const,
    foerderung32: () => [...queryKeys.admin.all, 'foerderung32'] as const,
    i18n: () => [...queryKeys.admin.all, 'i18n'] as const,
  },
};
